export default ($t) => ({
  title: "ActivateConfettiNow",
  type: "object",
  properties: {
    value: {
      title: "Active",
      type: "boolean",
      extended: true,
      default: false,
    },
    confetti_type: {
      title: $t("edit_campaign.schema_active_confetti_now_confetti_type", "Confetti type"),
      type: "enum",
      default: "default",
      extended: true,
      items: {
        title: "",
        type: "enum",
        default: "",
        enum: [
          {
            text: $t("edit_campaign.schema_active_confetti_now_confetti_type_default", "Default"),
            value: "default",
          },
          {
            text: $t("edit_campaign.schema_active_confetti_now_confetti_type_rose", "Rose"),
            value: "rose",
          },
        ],
      },
    },
  },
});
